import { render, staticRenderFns } from "./brought_games_table.vue?vue&type=template&id=251a85ea&lang=pug&"
import script from "./brought_games_table.vue?vue&type=script&lang=js&"
export * from "./brought_games_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports